import favicon from '../img/favicon-32x32.png';
import fullstack from '../img/fullstack.svg';
import scope from '../img/total_scope.svg';
import business from '../img/business.svg';
const WelcomePage = function(props) {
    return (
        <>
            <section className="overlay"><div>Coming Soon</div></section>
            <section className="background"></section>
            <header className="wmorr-color main-header">
                <div>
                    <button className="toggle-button">
                        <span className="toggle-button__bar"></span>
                        <span className="toggle-button__bar"></span>
                        <span className="toggle-button__bar"></span>
                    </button>
                    <a href="/index.html" className="main-header__brand">
                        <img src={favicon} alt="Westmorr Consulting, LLC - Business and Technology Consulting"/>
                    </a>
                </div>
            <nav>
            </nav>
            </header>
            <main>
                <article className="folio">
                    <section className="folio-plan photo-gallery">
                        <h3>Gallery</h3>
                    </section>
                    <section className="folio-plan site-gallery">
                        <h3>Site Comps</h3>
                    </section>
                    <section className="folio-plan fullstack-gallery">
                        <h3>Full Stack Development</h3>
                    </section>
                </article>
                <article className="history">
                    <h3>Experience</h3>
                    <ul className="history-items">         
                        <li className="history-item">
                            <div className="history-image">
                                <a href="https://blog.westmorr.com" target="_blank" rel="noreferrer">
                                <img src={business} alt="business meeting"/>
                                </a>         
                            </div>
                            <p>Business and Technology</p>   
                        </li>
                        <li className="history-item">
                            <div className="history-image">
                                <img src={scope} alt="multiple industries"/>
                            </div>
                            <p>Global Experience Across Industries</p> 
                        </li>
                        <li className="history-item">
                            <div className="history-image">
                                <img src={fullstack} alt="fullstack development"/>            
                            </div>
                            <p>Full Stack Architect</p> 
                        </li>
                    </ul>

                </article>
            </main>
            <footer>
                <span>&#169; Westmorr Consulting, LLC</span>
            </footer>
        </>
    );
};

export default WelcomePage;